import { IPagedListResponse } from "domain/types/global/pagedListResponse"
import { CarteiraPermissaoResponse } from "./carteiraPermissaoResponse"
import { UsuarioCarteiraResponse } from "./carteiraUsuarioResponse"
import { CarteiraPermissaoTipo } from 'domain/types/_carteira/carteiraAdmin/carteiraPermissaoTipo';

export const CARTEIRA_PERMISSAO_GET = 'CARTEIRA_PERMISSAO_GET'

export const CARTEIRA_USUARIO_GET = 'CARTEIRA_USUARIO_GET'

export const CARTEIRA_PERMISSAO_UPDATE = 'CARTEIRA_PERMISSAO_UPDATE'

export interface CarteiraAdminState {
    CarteiraPermissao: CarteiraPermissaoResponse | undefined,
    CarteiraUsuarios: IPagedListResponse<UsuarioCarteiraResponse> | undefined,
}

export interface CarteiraAdminAction {
    type: typeof CARTEIRA_PERMISSAO_GET,
    payload: CarteiraPermissaoResponse
}

export interface CarteiraUsuarioAction {
    type: typeof CARTEIRA_USUARIO_GET,
    payload: IPagedListResponse<UsuarioCarteiraResponse>
}

export interface CarteiraPermisaoUpdateAction {
    type: typeof CARTEIRA_PERMISSAO_UPDATE,
    payload: {UsuarioID: number, Status: boolean, CarteiraPermissaoTipoID: CarteiraPermissaoTipo}
}


export type CarteiraAdminActionTypes = CarteiraAdminAction | CarteiraUsuarioAction | CarteiraPermisaoUpdateAction;